import { dbMagicBall as db } from '../../firebase';
import { getBackendError } from 'common/utils';
import { isEmpty } from 'check-tool';
import { deleteUserItem, updateCntPushNotification } from './User';

const notificationMapper = (documentSnapshot) => {
  const { title, content, dateUpdated, number } = documentSnapshot.data();

  return {
    id: documentSnapshot.id,
    title,
    content,
    dateUpdated,
    number: number ? number : 0,
  };
};

const notificationListMapper = (docs) => {
  return docs.map((documentSnapshot) => notificationMapper(documentSnapshot));
};

export const getNotificationList = async () => {
  return new Promise((resolve, reject) => {
    db
      .collection('notification')
      .orderBy('number')
      .get()
      .then((querySnapshot) => resolve(notificationListMapper(querySnapshot.docs)))
      .catch((error) => {
        reject(getBackendError(error));
      });
  });
};


export const updateNotification = async (
  id,
  titleEn,
  titleRu,
  titleUk,
  titleEs,
  titlePt,
  titleIt,
  titlePl,
  contentEn,
  contentRu,
  contentUk,
  contentEs,
  contentPt,
  contentIt,
  contentPl,
  ) => {
  const date = new Date().getTime();
  return new Promise((resolve, reject) => {
    db
      .collection('question')
      .doc(id)
      .update({
        dateUpdated: date,
        title: {
          en: titleEn,
          ru: titleRu,
          uk: titleUk,
          es: titleEs,
          pt: titlePt,
          it: titleIt,
          pl: titlePl
        },
        content: {
          en: contentEn,
          ru: contentRu,
          uk: contentUk,
          es: contentEs,
          pl: contentPl,
          it: contentIt,
          pt: contentPt,
        }
      })
      .then(() => resolve())
      .catch((error) => {
        reject(getBackendError(error));
      });
  });
};

export const getNotificationItem = async (id) => {
  return new Promise((resolve, reject) => {
    db
      .collection('notification')
      .doc(id)
      .get()
      .then((querySnapshot) => {
        const { title, content, countSend } = querySnapshot.data();
        const obj = {
          id: querySnapshot.id,
          title,
          content,
          countSend,
        };
        resolve(obj);
      })
      .catch((error) => {
        reject(getBackendError(error));
      });
  });
};

export const createNotification = (
  number,
  titleEn,
  titleRu,
  titleUk,
  titleEs,
  titlePt,
  titleIt,
  titleCs,
  titleDe,
  titleFr,
  titleNl,
  titlePl,
  titleTk,
  titleSl,
  titleTh,
  titleHi,
  titleZh,
  titleZhCn,
  titleJa,
  titleEl,
  titleSv,
  titleNo,
  contentEn,
  contentRu,
  contentUk,
  contentEs,
  contentPt,
  contentIt,
  contentCs,
  contentDe,
  contentFr,
  contentNl,
  contentPl,
  contentTk,
  contentSl,
  contentTh,
  contentHi,
  contentZh,
  contentZhCn,
  contentJa,
  contentEl,
  contentSv,
  contentNo,
) => {
  const date = new Date().getTime();
  return new Promise((resolve, reject) => {
    db
      .collection('notification')
      .add({
        number: parseInt(number),
        dateCreated: date,
        dateUpdated: date,
        title: {
          en: titleEn,
          ru: titleRu,
          uk: titleUk,
          es: titleEs,
          pt: titlePt,
          it: titleIt,
          cs: titleCs,
          de: titleDe,
          fr: titleFr,
          nl: titleNl,
          pl: titlePl,
          tk: titleTk,
          sl: titleSl,
          th: titleTh,
          hi: titleHi,
          zh: titleZh,
          zhCn: titleZhCn,
          ja: titleJa,
          el: titleEl,
          sv: titleSv,
          no: titleNo,
        },
        content: {
          en: contentEn,
          ru: contentRu,
          uk: contentUk,
          es: contentEs,
          it: contentIt,
          pt: contentPt,
          cs: contentCs,
          de: contentDe,
          fr: contentFr,
          nl: contentNl,
          pl: contentPl,
          tk: contentTk,
          sl: contentSl,
          th: contentTh,
          hi: contentHi,
          zh: contentZh,
          zhCn: contentZhCn,
          ja: contentJa,
          el: contentEl,
          sv: contentSv,
          no: contentNo,
        }
      })
      .then(() => resolve())
      .catch((error) => {
        reject(getBackendError(error));
      });
  });
};

export const deleteNotificationItem = async (id) => {
  return new Promise((resolve, reject) => {
    db
      .collection('notification')
      .doc(id)
      .delete()
      .then(() => {
        resolve();
      })
      .catch((error) => {
        reject(getBackendError(error));
      });
  });
};


export const sendPushNotification = async (lang, users, notification) => {
  return new Promise((resolve, reject) => {
    let total = 0;
    users.forEach((value) => {
      const currentLang = value.language;
      if ((lang === 'all' || currentLang === lang) && (value.cntPushNotification === notification.number - 1 || notification.number === 99999)) {
        const notificationData = {
          title: notification.title[currentLang],
          body: notification.content[currentLang] ? notification.content[currentLang] : '-',
          vibrate: 1,
          sound: 1,
          show_in_foreground: true,
          priority: "high",
          content_available: true,
        };
        const data = {
          title: notification.title[currentLang],
          body: notification.content[currentLang] ? notification.content[currentLang] : '-',
          score: 50,
          wicket: 1,
        };
        total++;
        sendPushNotificationFetch(value.deviceToken, notificationData, data, value.cntPushNotification, value.platform);
      }
    });
    console.log('total', total);
    resolve();
  });
};

/*
  notification: {
    title: "This is a Notification",
    boby: "This is the body of the Notification",
    vibrate: 1,
    sound: 1,
    show_in_foreground: true,
    priority: "high",
    content_available: true,
  },
  data: {
    title: "This is a Notification",
    boby: "This is the body of the Notification",
    score: 50,
    wicket: 1,

  },
*/

const sendPushNotificationFetch = async (toDeviceToken, notification, data, cnt, platform) => {
    if (!isEmpty(toDeviceToken)) {
      const FIREBASE_API_KEY =
        'AAAASTk1ArU:APA91bH3k1vI8mIMZGuhCOG0hKivUmb2uGEU3tHU5EWu5HCs2iVx6d3_fxRNErDRA5s7CGKXAqjw3-ycj9i7aEls3zMazhWX9hjqBmF1e7rk-C03zpinq8R2sLfHLS9QiSaV-Gqx43fX';
      const message = {
        to: toDeviceToken,
        notification,
        data,
        foreground: true,
      };

      let headers = new Headers({
        'Content-Type': 'application/json',
        Authorization: 'key=' + FIREBASE_API_KEY,
      });

      let response = await fetch('https://fcm.googleapis.com/fcm/send', {
        method: 'POST',
        headers,
        body: JSON.stringify(message),
      });
      response = await response.json();
      if (response.success > 0) {
        updateCntPushNotification(toDeviceToken, cnt + 1);
      }
      if (response.failure > 0) {
        deleteUserItem(toDeviceToken);
        console.log('Delete token');
      }
    } else {
      console.log('cnt', cnt, toDeviceToken);
    }
};
